export const categories = {
  documents: ['.doc', '.docx', '.pdf', '.pptx', '.rtf', '.txt'],
  images: ['.ai', '.bmp', '.gif', '.ico', '.heif', '.jpeg', '.jpg', '.png', '.ps', '.svg', '.tif', '.tiff'],
  spreadsheets: ['.xls', '.xlsx', '.csv']
};

export const FileTypeCategories = {
  Documents: 'documents',
  Images: 'images',
  Spreadsheets: 'spreadsheets'
};

/** A map of the predefined types in `['key/value', 'display']` format */
export const predefinedTypes = new Map([
  // categories
  [FileTypeCategories.Documents, 'Documents'],
  [FileTypeCategories.Images, 'Images'],
  [FileTypeCategories.Spreadsheets, 'Spreadsheets'],
  // individual types
  ['.csv', '.csv'],
  ['.gif', '.gif'],
  ['.ps', '.ps']
]);

/**
 * Flattens a list of mixed file/category types.
 * @param fileTypes The list of mixed categories and individual types.
 */
export function flattenFileTypes(fileTypes: string[]): string[] {
  if (!fileTypes) {
    return [];
  }

  // maintain a set of types so we don't duplicate them
  const flattened = new Set<string>();

  fileTypes.forEach((type) => {
    if (!type || typeof type !== 'string') {
      return;
    }

    // look it up in the categories map
    const category = categories[type] || [type];

    category.forEach((item) => flattened.add(item));
  });

  return Array.from(flattened);
}
